/**
 * 主题集合
 * @type {string[]}
 */
export const Themes = ["ace/theme/chrome", "ace/theme/github","ace/theme/eclipse", "ace/theme/monokai", "ace/theme/textmate"]

/**
 * 代码集合
 * @type {[{label: string, value: string}]}
 */
export const ModeViews = [
    {label: 'Text', value: 'ace/mode/text'},
    {label: "HTML", value: "ace/mode/html"},
    {label: "CSS", value: "ace/mode/css"},
    {label: 'Javascript', value: 'ace/mode/javascript'},
    {label: 'Json', value: 'ace/mode/json'},
    {label: 'Java', value: 'ace/mode/java'},
    {label: 'SQL', value: 'ace/mode/sql'},
    // {label: 'Scss', value: 'ace/mode/scss'},
    // {label: 'Markdown', value: 'ace/mode/markdown'},
    // {label: 'Json5', value: 'ace/mode/json5'},
    // {label: 'JSP', value: 'ace/mode/jsp'},
    // {label: 'Markdown', value: 'ace/mode/markdown'},
    // {label: 'Mysql', value: 'ace/mode/mysql'},
    // {label: 'Nginx', value: 'ace/mode/nginx'},
    // {label: 'Objective-C', value: 'ace/mode/objectivec'},
    // {label: 'PHP', value: 'ace/mode/php'},
    // {label: 'Python', value: 'ace/mode/python'},
    // {label: 'Ruby', value: 'ace/mode/ruby'},
    // {label: 'SqlServer', value: 'ace/mode/sqlserver'},
    // {label: 'XML', value: 'ace/mode/xml'},
    // {label: 'Yaml', value: 'ace/mode/yaml'},
    // {label: "C++", value: "ace/mode/c_cpp"},
    // {label: "C#", value: "ace/mode/csharp"},
    // {label: "Dart", value: "ace/mode/dart"},
    // {label: "Dockerfile", value: "ace/mode/dockerfile"},
    // {label: "Dot脚本语言", value: "ace/mode/dot"},
    // {label: 'Typescript', value: 'ace/mode/typescript'},
    // {label: 'TSX', value: 'ace/mode/tsx'},
]

// 主题集合
export function getThemes() {
    let opts = []
    Themes.map(option => {
        let label = option.replace('ace/theme/', '')
        opts.push({
            label: titleCase(label),
            value: option
        })
    })

    return opts
}

//ES6写法
export function titleCase(str) {
    return str.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase());
}

export function getOption(value, type) {
    if (type === 'theme') {
        let themes = getThemes().find(t => t.value === value || t.label === titleCase(value))
        return themes ? themes.value : ""
    } else {
        let modes = ModeViews.find(t => t.value === value || t.label === titleCase(value))

        return modes ? modes.value : ""
    }
}
